import { authStateActions } from '@/state/actions'
import { Button, Tooltip } from 'antd'
import { LuLogOut } from 'react-icons/lu'

import './index.scss'
import TopbarUserInfo from '../layout/topbar/userinfo'
import OfflineManagement from '@/components/offline-management'
import { OfflineState } from '@/state/offline-management'

export default function UserGlobalMenu() {
  const showLogout =
    OfflineState.isOnline.value && !OfflineState.isSynchronizing.value

  return (
    <div className='user-menu'>
      <OfflineManagement />

      <TopbarUserInfo />

      {showLogout && (
        <Tooltip title='Cerrar sesión' placement='left'>
          <Button
            className='user-menu-btn'
            onClick={authStateActions.handleLogout}
            icon={<LuLogOut size={20} />}
            shape='circle'
          />
        </Tooltip>
      )}
    </div>
  )
}
